"use client";

import { Cover, Video } from "politicamente-informados-ds";

import { BlocksProps } from "@/lib/wordpress/_types/blocksStyle";
import DisplayImage from "@/components/common/DisplayImage/DisplayImage";
import displayBlock from "@/lib/wordpress/blocks/displayBlock";

export type IBlockCover = {
  attrs: {
    id?: string;
    anchor?: string;
    url?: string;
    alt?: string;
    minHeight?: string;
    minHeightUnit?: string;
    contentPosition?: string;
    isRepeated?: boolean;
    hasParallax?: boolean;
    dimRatio?: number;
    overlayColor?: string;
    customOverlayColor?: string;
    backgroundType?: string;
    priority?: boolean;
    className?: string;
    style?: Record<string, unknown>;
  };
  innerBlocks: BlocksProps[];
};

export default function BlockCover({ attrs, innerBlocks }: IBlockCover) {
  const {
    id,
    anchor,
    url,
    alt,
    minHeight,
    minHeightUnit,
    contentPosition,
    isRepeated,
    hasParallax,
    dimRatio,
    overlayColor,
    customOverlayColor,
    backgroundType,
    priority,
    className,
    style,
  } = attrs;

  if (!url) {
    return null;
  }

  const overlayOpacity = url && dimRatio ? dimRatio / 100 : 1;

  return (
    <Cover
      minHeight={minHeight && `${minHeight}${minHeightUnit || "px"}`}
      contentPosition={contentPosition
        ?.replaceAll("top", "flex-start")
        .replaceAll("bottom", "flex-end")}
      imageElement={
        <>
          {backgroundType === "video" ? (
            <Video
              src={url}
              autoplay={true}
              controls={false}
              loop={false}
              muted={true}
              playsInline={true}
            ></Video>
          ) : (
            <DisplayImage
              alt={alt ? alt : ""}
              url={url}
              fill={true}
              priority={priority}
            />
          )}
        </>
      }
      // isRepeated={isRepeated}
      // hasParallax={hasParallax}
      overlayOpacity={overlayOpacity}
      overlayColor={overlayColor || customOverlayColor}
      className={className}
      style={style}
    >
      <div>
        {!!innerBlocks?.length &&
          innerBlocks.map((block: BlocksProps, index: number) => {
            return displayBlock(block as BlocksProps, index);
          })}
      </div>
    </Cover>
  );
}
